import React from 'react';
import Button from 'gatsby-theme-core/src/components/button/index';
import styled from 'styled-components';

const VariantButton = ({
  variant,
  ...rest
}) => (
  <Button
    primary={variant === 'primary'}
    dark={variant === 'dark'}
    outline={variant === 'outline'}
    outlineWhite={variant === 'outlineLight' || variant === 'outlineWhite'}
    outlineDark={variant === 'outlineDark'}
    link={variant === 'link'}
    standout={variant === 'standout'}
    {...rest}
  />
);

export default styled(VariantButton)``;
